import { RoutePermittedRole } from 'constants/AppConst';
import { ROUTE_STRING } from 'constants/RouteString';
import List from './List';
import Add from './Add';
import Detail from './Detail';
import AllowedAccess from '@tenant/core/AppPermission/AllowedAccess';
import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';
import ListIDP from './ListIDP';


export const appInstanceRoutes = [
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.APP_INSTANCE.LIST],
    element: (
      <AllowedAccess permissionIds={[AuthorizePermission.APP_INSTANCE_READ]}>
        <List />
      </AllowedAccess>
    ),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.APP_INSTANCE.ADD],
    element: (
      <AllowedAccess permissionIds={[AuthorizePermission.APP_INSTANCE_CREATE]}>
        <Add />
      </AllowedAccess>
    ),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.APP_INSTANCE.VIEW],
    element: (
      <AllowedAccess permissionIds={[AuthorizePermission.APP_INSTANCE_READ]}>
        <Detail />
      </AllowedAccess>
    ),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.IDP_CLIENT.LIST],
    element: (
      <AllowedAccess permissionIds={[AuthorizePermission.IDP_CLIENT_READ]}>
        <ListIDP />
      </AllowedAccess>
    ),
  },
];
